import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Drawer, message } from 'antd';
import axios from 'axios';

import DrawerSubmitFooter from '../../../common/containers/DrawerSubmitFooter';

import SageIntacctIntegration from './SageIntacctIntegration';

import {
  updateSageIntacctIntegration,
} from '../../state/settings.actions';

function SageIntacctIntegrationDrawer({
  visible,
  onClose,
  selectedIntegration,
}) {
  const dispatch = useDispatch();
  const [integration, setIntegration] = useState(selectedIntegration);

  const onIntegrationChanged = useCallback((newData) => {
    setIntegration({
      ...integration,
      ...newData,
    });
  }, [integration]);

  const onSubmit = useCallback(async () => {
    if (!integration?.id) {
      // Initiate OAuth flow for new integration
      try {
        const { data } = await axios.post('/sage/intacct/oauth/authorize', {
          divisions: integration?.divisions,
          defaultDivisionId: integration?.defaultDivisionId,
          name: integration?.name,
        });
        if (data?.authorizationUrl) {
          window.location.href = data.authorizationUrl;
        } else {
          message.error('Failed to get authorization URL');
        }
      } catch (err) {
        message.error('Failed to initiate Sage Intacct authorization');
      }
    } else {
      const { id, ...details } = integration;
      const updated = await dispatch(updateSageIntacctIntegration(id, details));
      if (updated) onClose();
    }
  }, [onClose, integration, dispatch]);

  useEffect(() => {
    setIntegration(visible ? selectedIntegration : null);
  }, [visible, selectedIntegration]);

  return (
    <Drawer
      visible={visible}
      width={600}
      onClose={onClose}
      getContainer={() => document.body}
      title={
        selectedIntegration
          ? 'Edit Sage Intacct Integration'
          : 'Add Sage Intacct Integration'
      }
    >
      <SageIntacctIntegration
        visible={visible}
        selectedIntegration={integration}
        onIntegrationChanged={onIntegrationChanged}
        onClose={onClose}
      />
      <DrawerSubmitFooter
        onClose={onClose}
        onSubmit={onSubmit}
        canSubmit={!!(integration?.divisions?.length && integration?.defaultDivisionId)}
      />
    </Drawer>
  );
}

SageIntacctIntegrationDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedIntegration: PropTypes.shape({
    divisionIds: PropTypes.arrayOf(PropTypes.string),
  }),
};

SageIntacctIntegrationDrawer.defaultProps = {
  selectedIntegration: null,
};

export default SageIntacctIntegrationDrawer;
